var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19664,
    y: 0.782085,
    width: 29.1624,
    height: 29.1624,
    rx: 2.93162,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.19664,
    y: 0.782085,
    width: 29.1624,
    height: 29.1624,
    rx: 2.93162,
    stroke: "#E5E7EB",
    strokeWidth: 0.837607
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_20635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9856 14.2467L15.7776 17.0387M15.7776 17.0387L18.5697 14.2467M15.7776 17.0387V10.3379M21.3617 17.0387V19.2724C21.3617 19.5686 21.244 19.8526 21.0346 20.0621C20.8251 20.2715 20.5411 20.3892 20.2449 20.3892H11.3104C11.0142 20.3892 10.7302 20.2715 10.5207 20.0621C10.3113 19.8526 10.1936 19.5686 10.1936 19.2724V17.0387",
    stroke: "black",
    strokeWidth: 1.11681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_20635"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4017,
    height: 13.4017,
    fill: "white",
    transform: "translate(9.0769 8.6626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.7fa7e54a6e739c2e5b78104d6a6de3c2.svg";
export { ForwardRef as ReactComponent };